import { ThumbsUp } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { cn } from "@/lib/utils";

export default function LikeButton({ likes, endpoint, reload, testid }) {
  const { user } = useAuth();
  const list = likes || [];
  const liked = user ? list.includes(user.id) : false;
  const count = list.length;

  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await api.post(endpoint);
      if (reload) reload();
    } catch (err) {
      toast.error("Couldn't update reaction");
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid={testid}
      aria-pressed={liked}
      className={cn(
        "inline-flex items-center gap-1.5 text-xs rounded-full border px-2.5 py-1 transition-colors active:scale-[0.97]",
        liked
          ? "bg-slate-900 text-white border-slate-900"
          : "text-slate-500 border-slate-200 hover:bg-slate-50 hover:text-slate-700"
      )}
    >
      <ThumbsUp className="h-3.5 w-3.5" />
      {count > 0 && <span>{count}</span>}
    </button>
  );
}
